import { render, staticRenderFns } from "./caiGouPurchaseCompletedLowPrice.vue?vue&type=template&id=f2b371d2&scoped=true"
import script from "./caiGouPurchaseCompletedLowPrice.vue?vue&type=script&lang=js"
export * from "./caiGouPurchaseCompletedLowPrice.vue?vue&type=script&lang=js"
import style0 from "./caiGouPurchaseCompletedLowPrice.vue?vue&type=style&index=0&id=f2b371d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b371d2",
  null
  
)

export default component.exports